import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Format USD for revenue/business amounts (always 2 decimals).
 * e.g. 2820 → "$2,820.00", 0 → "$0.00"
 */
export function formatCurrency(amount: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
}

/**
 * Format USD for API/processing costs (up to 4 decimals, minimum 2).
 * Shows precision for small costs like $0.0015/page.
 * e.g. 0.303 → "$0.3030", 0.1515 → "$0.1515", 0 → "$0.00"
 */
export function formatCostUsd(amount: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 4,
    maximumFractionDigits: 4,
  }).format(amount);
}

/**
 * Format a number with thousand separators.
 * e.g. 12345 → "12,345"
 */
export function formatNumber(num: number): string {
  return new Intl.NumberFormat('en-US').format(num);
}
